/* Avysera colour sweep. One job, cosmetic, undone by deleting the one line in
   theme.liquid that loads this file. Nothing on disk is changed.

   Any leftover light blue becomes the box navy. Most of the store's blues are
   handled by the stylesheet; a few are set by rules it cannot outrank, or are
   painted late by apps, so they are matched on the computed colour instead,
   which catches them wherever they come from. On the product page that is what
   picks up the ~140 inline SVG icon fills the stylesheet has no handle on.

   Two regions are skipped because they own their palette deliberately:
   #avy-scroll (the film on the home page) and #avy-c (the rebuilt product
   page). Photography is never touched — this only rewrites colour properties. */
(function () {
  "use strict";

  var SWEPT = "avySw";

  var NAVY = "rgb(22, 80, 122)";
  var MAP = {
    "rgb(43, 200, 217)": NAVY,   // #2bc8d9
    "rgb(0, 193, 222)":  NAVY,   // #00c1de
    "rgb(2, 193, 222)":  NAVY,   // #02c1de
    "rgb(0, 194, 233)":  NAVY,   // #00c2e9
    "rgb(23, 168, 184)": NAVY,   // #17a8b8
    "rgb(79, 212, 226)": NAVY,   // #4fd4e2
    "rgb(217, 245, 249)": "rgba(22, 80, 122, 0.12)", // pale tint
    "rgb(140, 226, 236)": "rgb(168, 200, 224)"       // light, sits on a dark banner
  };

  function owned(el) {
    return el.closest && (el.closest("#avy-scroll") || el.closest("#avy-c"));
  }

  /* ---------- colours ---------- */
  function sweepColour(el) {
    if (el.dataset[SWEPT] === "1" || owned(el)) return;
    el.dataset[SWEPT] = "1";
    var c = getComputedStyle(el);
    if (MAP[c.backgroundColor]) el.style.setProperty("background-color", MAP[c.backgroundColor], "important");
    if (MAP[c.color]) el.style.setProperty("color", MAP[c.color], "important");
    if (MAP[c.borderBottomColor] && parseFloat(c.borderBottomWidth) > 0)
      el.style.setProperty("border-bottom-color", MAP[c.borderBottomColor], "important");
    if (MAP[c.borderTopColor] && parseFloat(c.borderTopWidth) > 0)
      el.style.setProperty("border-top-color", MAP[c.borderTopColor], "important");
    if (MAP[c.borderLeftColor] && parseFloat(c.borderLeftWidth) > 0)
      el.style.setProperty("border-left-color", MAP[c.borderLeftColor], "important");
    if (MAP[c.borderRightColor] && parseFloat(c.borderRightWidth) > 0)
      el.style.setProperty("border-right-color", MAP[c.borderRightColor], "important");
    if (MAP[c.outlineColor]) el.style.setProperty("outline-color", MAP[c.outlineColor], "important");
    if (MAP[c.fill]) el.style.setProperty("fill", MAP[c.fill], "important");
    if (MAP[c.stroke]) el.style.setProperty("stroke", MAP[c.stroke], "important");
  }

  function pass(root) {
    var r = root || document;
    if (!r.querySelectorAll) return;
    if (r.nodeType === 1) sweepColour(r);
    r.querySelectorAll("*").forEach(sweepColour);
  }

  function start() {
    pass(document);
    var obs = new MutationObserver(function (muts) {
      obs.disconnect();                       // never react to our own writes
      try {
        for (var i = 0; i < muts.length; i++) {
          var add = muts[i].addedNodes;
          for (var j = 0; j < add.length; j++)
            if (add[j].nodeType === 1) pass(add[j]);
        }
      } finally { obs.observe(document.documentElement, { childList: true, subtree: true }); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // apps paint late, so one more sweep after things settle
    setTimeout(function () { pass(document); }, 1500);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
